export class SchoolResponse {
  schoolId: number;
  schoolNumber: number;
  centerCode: string;
  description: string;
  batch: string;
  manager: string;
  centerType: string;
  serviceType: string;
  schoolAccount: string;
  invoiceAccount: string;
  attendanceReport: boolean;
}
